import types from '../../types';

const userHotTransactions = (state = { loading: true }, { type, payload }) => {
  switch (type) {
    case types.GET_USER_HOT_TRANSACTIONS_SUCCESS:
      return { ...payload, loading: false };

    case types.GET_USER_HOT_TRANSACTIONS_START:
      return { ...state, loading: true };

    case types.GET_USER_HOT_TRANSACTIONS_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default userHotTransactions;
